
import Api from '@/services/Api'

export default {
  validateFiles (params, token) {
    return Api().post('upload/0', params, {headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  uploadFiles (params, token) {
    return Api().post('upload/1', params, {headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  validateFilesEducational (params, token) {
    return Api().post('upload/educational/0', params, {headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  uploadFilesEducational (params, token) {
    return Api().post('upload/educational/1', params, {headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchArchives (token) {
    return Api().get('archives/provider', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchArchivesEstudents (token) {
    return Api().get('archives/educational', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  delArchive (params, token) {
    return Api().delete('archives/' + params.id, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  }
}

// window.open(this.$parent.envVars.API_BASE_URL + '/api/v1/courses/download/' + mediaId, '_blank')



// WEBPACK FOOTER //
// ./src/services/ArchivesService.js